import React, { useEffect } from 'react';
import { formatDate, handleClickLinks } from '../includes/utils';
import PropTypes from "prop-types";

export default function CsfFournisseurFormationsList({ formations, urlDetailFormation }) {

  const langcode = document.documentElement.lang;

  return (
    <div>
      {formations.length === 0 ? (
        <p>{window.Drupal.t('fournisseur.empty.training.list')}</p>
      ) : (
        formations.map((item) => (
          <article className="list-item" key={item.REDU_Activity_Id}>
            <div className="list-item-desc">
              {item.Name_French && (
                <span>{item.Name_French}</span>
              )}
              {item.Name_English && (
                <span>{item.Name_English}</span>
              )}
            </div>
            <div className="list-item-status">
              {item.Flag === 1 && (
                <img src="/themes/custom/tink/dist/assets/icn-warning.svg" data-toggle="tooltip"
                  title={item.Flag__Choice} alt="Tooltip icon" />
              )}
              {item.Flag === 2 && (
                <img src="/themes/custom/tink/dist/assets/icn-error.svg" data-toggle="tooltip"
                  title={item.Flag__Choice} alt="Tooltip icon" />
              )}
            </div>
            <div className="list-item-details">
              <span>{langcode === 'fr' ? item.Status_Name_French : item.Status_Name_English}</span>
              {item.LastModif && (
                <span dangerouslySetInnerHTML={{ __html: window.Drupal.t('fournisseur.last.modification.date.html') + ' ' + formatDate(item.LastModif) }}></span>
              )}
            </div>
            <div className="list-item-cta">
              <button className={item.Flag !== 0 ? "button" : "button btn-outlined"} aria-label={`${window.Drupal.t('fournisseur.open.btn.label')} ${item.Name_French} ${(item.Name_English ? " / " + item.Name_English : "")}`} onClick={() => handleClickLinks(urlDetailFormation, 'activity', item.REDU_Activity_Id)}>
                {window.Drupal.t('fournisseur.open.btn.label')}</button>
            </div>
          </article>
        )))}
    </div>
  )
}

CsfFournisseurFormationsList.propTypes = {
  formations: PropTypes.array,
  urlDetailFormation: PropTypes.string,
};
